import React, { useRef, useState } from "react";
import { Button } from "../ui/button";
import { Upload, X, Image as ImageIcon } from "lucide-react";

const ImageUploader = ({ onChange, value = [] }) => {
  const fileInputRef = useRef(null);
  const [previews, setPreviews] = useState(
    (value || []).map((fileOrUrl) => {
      if (typeof fileOrUrl === "string") return fileOrUrl; // existing URL
      if (fileOrUrl instanceof File || fileOrUrl instanceof Blob)
        return URL.createObjectURL(fileOrUrl);
      return ""; // skip invalid
    }).filter(Boolean)
  );

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const validFiles = files.filter((file) =>
      file.type.startsWith("image/")
    );

    if (validFiles.length !== files.length) {
      alert("Some files were skipped because they are not images.");
    }

    const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
    setPreviews((prev) => [...prev, ...newPreviews]);
    onChange([...(value || []), ...validFiles]);
  };

  const handleRemove = (index) => {
    const newPreviews = previews.filter((_, i) => i !== index);
    const newFiles = value.filter((_, i) => i !== index);
    setPreviews(newPreviews);
    onChange(newFiles);
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-3">
        {previews.map((src, index) => (
          <div key={index} className="relative w-24 h-24">
            <img
              src={src}
              alt={`Upload preview ${index}`}
              className="w-24 h-24 object-cover rounded-lg border"
            />
            <button
              type="button"
              onClick={() => handleRemove(index)}
              className="absolute -top-2 -right-2 bg-red-500 text-white p-1 rounded-full shadow hover:bg-red-600"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}

        <div
          onClick={() => fileInputRef.current.click()}
          className="w-24 h-24 flex items-center justify-center rounded-lg border border-dashed bg-muted cursor-pointer hover:bg-accent transition"
        >
          <ImageIcon className="w-8 h-8 text-muted-foreground" />
        </div>
      </div>

      <input
        type="file"
        accept="image/*"
        multiple
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileSelect}
      />

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => fileInputRef.current.click()}
      >
        <Upload className="w-4 h-4 mr-2" />
        {previews.length > 0 ? "Add More Images" : "Upload Images"}
      </Button>
    </div>
  );
};

export default ImageUploader;
